import ROUTES from './routes';

export const WITHOUT_SESSION_PATH = ['/redirect'];

export const AUTH0_REDIRECT_PATH = '/redirect';

export const DEFAULT_AUTH0_APP_REDIRECTION_PATH = ROUTES.APPLICATION;

export const INVITE_MEMBERS_HASH = '#invite-team-members';

export const SIGNOZ_UPGRADE_PLAN_URL =
	'https://upgrade.signoz.io/upgrade-from-app';

export const DASHBOARD_TIME_IN_DURATION = 'refreshInterval';

export const DEFAULT_ENTITY_VERSION = 'v3';
export const ENTITY_VERSION_V4 = 'v4';
export const ENTITY_VERSION_V5 = 'v5';
